import React from "react";
import { Container } from "reactstrap";

import {
  carouselItems,
  LitterIntro,
  LitterPage,
  LitterPuppyGrid,
  ParentPedigree,
  VideoSection
} from "components/Litters/LitterComponents.js";
import SEO from "components/SEO/SEO.js";
import DogGallery from "../dogs/DogGallery";

const announcement = require("../../assets/img/dogs/litters/vr2023/announcement.jpg");
const pedigreeImage = require("../../assets/img/dogs/litters/vr2023/pedigree.jpg");
const ripProfile = require("../../assets/img/dogs/profile-rip.jpg");
const venusProfile = require("../../assets/img/dogs/profile-venus2.jpg");
const agilityIcon = require("../../assets/img/icon-agility.png");
const discIcon = require("../../assets/img/icon-disc.png");
const flyballIcon = require("../../assets/img/icon-flyball.png");

const puppyImages = {
  kiki: [
    require("../../assets/img/dogs/litters/vr2023/kiki7.jpg"),
    require("../../assets/img/dogs/litters/vr2023/kiki6.jpg"),
    require("../../assets/img/dogs/litters/vr2023/kiki5.jpg"),
    require("../../assets/img/dogs/litters/vr2023/kiki4.jpg"),
    require("../../assets/img/dogs/litters/vr2023/kiki3.jpg"),
    require("../../assets/img/dogs/litters/vr2023/kiki2.jpg"),
    require("../../assets/img/dogs/litters/vr2023/kiki1.jpg")
  ],
  totoro: [
    require("../../assets/img/dogs/litters/vr2023/totoro7.jpg"),
    require("../../assets/img/dogs/litters/vr2023/totoro6.jpg"),
    require("../../assets/img/dogs/litters/vr2023/totoro5.jpg"),
    require("../../assets/img/dogs/litters/vr2023/totoro4.jpg"),
    require("../../assets/img/dogs/litters/vr2023/totoro3.jpg"),
    require("../../assets/img/dogs/litters/vr2023/totoro2.jpg"),
    require("../../assets/img/dogs/litters/vr2023/totoro1.jpg")
  ],
  sophie: [
    require("../../assets/img/dogs/litters/vr2023/sophie7.jpg"),
    require("../../assets/img/dogs/litters/vr2023/sophie6.jpg"),
    require("../../assets/img/dogs/litters/vr2023/sophie5.jpg"),
    require("../../assets/img/dogs/litters/vr2023/sophie4.jpg"),
    require("../../assets/img/dogs/litters/vr2023/sophie3.jpg"),
    require("../../assets/img/dogs/litters/vr2023/sophie2.jpg"),
    require("../../assets/img/dogs/litters/vr2023/sophie1.jpg")
  ],
  haku: [
    require("../../assets/img/dogs/litters/vr2023/haku7.jpg"),
    require("../../assets/img/dogs/litters/vr2023/haku6.jpg"),
    require("../../assets/img/dogs/litters/vr2023/haku5.jpg"),
    require("../../assets/img/dogs/litters/vr2023/haku4.jpg"),
    require("../../assets/img/dogs/litters/vr2023/haku3.jpg"),
    require("../../assets/img/dogs/litters/vr2023/haku2.jpg"),
    require("../../assets/img/dogs/litters/vr2023/haku1.jpg")
  ],
  ponyo: [
    require("../../assets/img/dogs/litters/vr2023/ponyo7.jpg"),
    require("../../assets/img/dogs/litters/vr2023/ponyo6.jpg"),
    require("../../assets/img/dogs/litters/vr2023/ponyo5.jpg"),
    require("../../assets/img/dogs/litters/vr2023/ponyo4.jpg"),
    require("../../assets/img/dogs/litters/vr2023/ponyo3.jpg"),
    require("../../assets/img/dogs/litters/vr2023/ponyo2.jpg"),
    require("../../assets/img/dogs/litters/vr2023/ponyo1.jpg")
  ],
  howl: [
    require("../../assets/img/dogs/litters/vr2023/howl7.jpg"),
    require("../../assets/img/dogs/litters/vr2023/howl6.jpg"),
    require("../../assets/img/dogs/litters/vr2023/howl5.jpg"),
    require("../../assets/img/dogs/litters/vr2023/howl4.jpg"),
    require("../../assets/img/dogs/litters/vr2023/howl3.jpg"),
    require("../../assets/img/dogs/litters/vr2023/howl2.jpg"),
    require("../../assets/img/dogs/litters/vr2023/howl1.jpg")
  ],
  chihiro: [
    require("../../assets/img/dogs/litters/vr2023/chihiro7.jpg"),
    require("../../assets/img/dogs/litters/vr2023/chihiro6.jpg"),
    require("../../assets/img/dogs/litters/vr2023/chihiro5.jpg"),
    require("../../assets/img/dogs/litters/vr2023/chihiro4.jpg"),
    require("../../assets/img/dogs/litters/vr2023/chihiro3.jpg"),
    require("../../assets/img/dogs/litters/vr2023/chihiro2.jpg"),
    require("../../assets/img/dogs/litters/vr2023/chihiro1.jpg")
  ]
};

const galleryImages = [
  require("../../assets/img/dogs/litters/vr2023/reg1.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg2.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg3.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg4.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg5.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg6.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg7.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg8.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg9.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg10.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg11.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg12.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg13.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg14.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg15.jpg"),
  require("../../assets/img/dogs/litters/vr2023/reg16.jpg")
];

const sportUpdates = [
  {
    title: "Flyball",
    icon: flyballIcon,
    image: require("../../assets/img/dogs/litters/vr2023/flyball.jpg"),
    imageAlt: "Venus x Rip offspring competing in flyball",
    paragraphs: [
      "Asher, Decoy, and Shea are competing in flyball. Asher plays on That's So Fetch. Decoy plays on Rocket Relay. Shea plays on Like Magic."
    ],
    stats: ["Decoy: 3.64", "Asher: 3.9", "Shea: 3.8"]
  },
  {
    title: "Agility",
    icon: agilityIcon,
    image: require("../../assets/img/dogs/litters/vr2023/agility.jpg"),
    imageAlt: "Venus x Rip offspring training agility",
    paragraphs: [
      "Ricochet, Asher, Cool, Seeker, and Squeeze are currently training competitively in agility.",
      "Videos of their agility runs can be found on the FB page."
    ]
  },
  {
    title: "Disc",
    icon: discIcon,
    image: require("../../assets/img/dogs/litters/vr2023/disc.jpg"),
    imageAlt: "Venus x Rip offspring playing disc",
    paragraphs: [
      "Asher has competed in UpDog events. He qualified for Updif 2026 in Far Out.",
    ]
  }
];

const puppies = [
  {
    name: "Ricochet",
    registeredName: "Endgame's Shoot for the Stars",
    images: carouselItems(puppyImages.kiki),
    details: [
      { label: "Litter name", value: "Kiki" },
      { label: "Stats", value: "Female" },
      { label: "Owner", value: "Lee-Ann Carr" },
      { label: "Location", value: "Alberta" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" },
      { label: "Hips", value: "OFA Excellent" },
      { label: "Shoulders", value: "Normal" },
      { label: "Elbows", value: "Normal" }
    ]
  },
  {
    name: "Asher",
    registeredName: "Endgame's Shadow in the Ember",
    images: carouselItems(puppyImages.totoro),
    details: [
      { label: "Litter name", value: "Totoro" },
      { label: "Stats", value: "Male" },
      { label: "Owner", value: "Erin Jenkins" },
      { label: "Location", value: "SC" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" },
      { label: "Hips", value: "Pennhip .25/.31" }
    ]
  },
  {
    name: "Cool",
    registeredName: "Endgame's Super Cool",
    images: carouselItems(puppyImages.sophie),
    details: [
      { label: "Litter name", value: "Sophie" },
      { label: "Stats", value: "Female" },
      { label: "Owner", value: "Monica Bush" },
      { label: "Location", value: "AZ" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" },
      { label: "Hips", value: "OFA Excellent" },
      { label: "Shoulders", value: "Normal" },
      { label: "Elbows", value: "Normal" }
    ]
  },
  {
    name: "Decoy",
    registeredName: "Endgame's Lure Them In",
    images: carouselItems(puppyImages.haku),
    details: [
      { label: "Litter name", value: "Haku" },
      { label: "Stats", value: "Male" },
      { label: "Owner", value: "Meghan Reitsma" },
      { label: "Location", value: "Ontario" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal (2023), Punctate Cataract - B/O, significance unknown (2025)" },
      { label: "Hips", value: "OFA Excellent" },
      { label: "Shoulders", value: "Normal" },
      { label: "Elbows", value: "Normal" }
    ]
  },
  {
    name: "Squeeze",
    registeredName: "Endgame's Fresh Squeeze",
    images: carouselItems(puppyImages.ponyo),
    details: [
      { label: "Litter name", value: "Ponyo" },
      { label: "Stats", value: "Female" },
      { label: "Owner", value: "M Nicole Fischer / Adriana Nottestad" },
      { label: "Location", value: "PA" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" }
    ]
  },
  {
    name: "Seeker",
    registeredName: "Endgame's Source of Magic",
    images: carouselItems(puppyImages.howl),
    details: [
      { label: "Litter name", value: "Howl" },
      { label: "Stats", value: "Male" },
      { label: "Owner", value: "Karah Gerelus" },
      { label: "Location", value: "Alberta" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" },
      { label: "Hips", value: "Pennhip .37/.34" }
    ]
  },
  {
    name: "Shea",
    registeredName: "Endgame's It's Outta Here",
    images: carouselItems(puppyImages.chihiro),
    details: [
      { label: "Litter name", value: "Chihiro" },
      { label: "Stats", value: "Female" },
      { label: "Owner", value: "Theresa Deutsch" },
      { label: "Location", value: "VA" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" }
    ]
  }
];

const parentHealthSummaries = [
  {
    name: "Rip",
    breed: "Border Collie",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=1543452",
    results: [
      { label: "Hips", value: "OFA Good" },
      { label: "Eyes", value: "Clear" },
      { label: "DNA", value: "CEA carrier" }
    ]
  },
  {
    name: "Venus",
    breed: "Border Collie",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=2263105",
    results: [
      { label: "Hips", value: "Pennhip .32/.35, OFA Good" },
      { label: "Elbows", value: "Normal" },
      { label: "Shoulders", value: "Normal" },
      { label: "Adv Cardiac", value: "Clear" },
      { label: "Eyes", value: "Clear, PTSO" },
      { label: "DNA", value: "Clear" }
    ]
  }
];

function VR2023Page() {
  return (
    <>
      <SEO
        title="Venus x Rip 2023 | Border Collie Puppies"
        description="See the Venus x Rip 2023 border collie puppies from Endgame Sport Dogs near Raleigh NC, including puppy profiles, health results, training videos, and sport dog litter updates."
        path="/litters/venus-rip-2023"
      />
      <LitterPage
        headerBg="vr2023"
        pageClassName="litter-detail-page litter-detail-page-modern"
        footerVariant="dark"
      >

        <section className="litter-detail-section litter-overview-section">
          <Container>
            <LitterIntro
              title="Venus × Rip"
              eyebrow="Border Collie Litter - 2023"
              announcement={announcement}
              announcementAlt="Rip x Venus litter announcement"
              finalCopy={
                <p>
                  For more information about <a className="litter-inline-link" href="/dogs/venus">Venus</a>, view her individual page. For more information on Rip, contact Erin Rakosky or reach out to me if you would like to learn about this cross.
                </p>
              }
              healthParents={parentHealthSummaries}
              overviewCopy={
                <>
                  <p>Rip is a well known dog in the flyball community. He's been on two winning multibreed teams with a personal best of 3.63. He has many offspring showing similar athletic talents in flyball and agility currently. Like Venus, he is very friendly with people, tolerant of other dogs, and has no environmental sensitivities. I'm expecting this breeding to produce friendly, high drive puppies who will thrive in experienced sport homes or with intermediate level handlers who are looking for a competitive dog. Rip competed in flyball and herding. He is now 13 years old, healthy, and retired from sports. Venus competes in flyball, herding, and dock diving. Preference will be for agility and/or flyball homes.</p>
                  <p>Rip's OFA link includes multiple offspring's results. Rip is 21" tall and 45lbs. Venus is 18" tall and 30lbs. There is a possibility for smooth or rough coats. Puppies will be registered with AKC. BAER and CAER testing will be done before the puppies go home.</p>
                </>
              }
              variant="modern"
            />
            <ParentPedigree
              className=""
              parents={[
                { name: "Rip", breed: "Border Collie", image: ripProfile },
                { name: "Venus", breed: "Border Collie", image: venusProfile, href: "/dogs/venus" }
              ]}
              pedigree={{
                image: pedigreeImage,
                href: "https://bc-db.ru/en/pets/55925/pedigree"
              }}
              variant="modern"
            />
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Parent Videos"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.youtube.com/embed/PEZiEg6K7_U", caption: "Venus - Flyball" },
                { src: "https://www.youtube.com/embed/a-rC0b1lkhA", caption: "Venus - Sport Video" },
                { src: "https://www.youtube.com/embed/FLq8oAcL3lM", caption: "Rip - Sport Video" },
                { src: "https://www.youtube.com/embed/nkXsiEWzzok", caption: "Rip - Sport Video" }
              ]}
            />
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section litter-group-video-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Related Dogs"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2F100004649957922%2Fvideos%2F619954396198539%2F&show_text=false&width=560&t=0", caption: "W Ei Ji & Serina (father: Rafter W Flank)" },
                { src: "https://www.youtube.com/embed/SsPH2NmyoHQ", caption: "Grace Heck & Ember (mother: Cindy)" },
                { src: "https://www.youtube.com/embed/xBLhzM6EpFs", caption: "Classic & Stacie (Rip x Hallelujah)" },
                { src: "https://www.youtube.com/embed/3hBJzTm6Lnw", caption: "Reef & Erin (Rip x Cyclone)" }
              ]}
            />
          </Container>
        </section>

        <LitterPuppyGrid
          summary="Venus had an easy labor and gave birth to 7 puppies on May 13th, 2023. The litter theme was Studio Ghibli movie characters."
          puppies={puppies}
          variant="modern"
        />
        <section className="litter-detail-section litter-updates-section">
          <Container>
            <div className="litter-detail-section-heading">
              <h2>Litter Updates</h2>
              <span className="dog-detail-heading-line" aria-hidden="true"></span>
            </div>
            <div className="litter-update-list">
              {sportUpdates.map(update => (
                <article className="litter-update-item" key={update.title}>
                  <div className="litter-update-icon" aria-hidden="true">
                    <img alt="" src={update.icon} />
                  </div>
                  <div className="litter-update-copy">
                    <h3>{update.title}</h3>
                    {update.paragraphs.map(paragraph => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                    {update.stats && (
                      <div className="litter-update-stats" aria-label={`${update.title} personal bests`}>
                        {update.stats.map(stat => (
                          <span key={stat}>{stat}</span>
                        ))}
                      </div>
                    )}
                  </div>
                  <img className="litter-update-image" alt={update.imageAlt} src={update.image} />
                </article>
              ))}
            </div>
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section litter-group-video-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Litter Videos"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.youtube.com/embed/FjbUeiWR_do?si=fgUrQm-HfD1YKFr8", caption: "2 Years - All" },
              ]}
            />
          </Container>
        </section>

        <section className="litter-detail-section litter-gallery-section dog-gallery-section site-bg-dark-navy">
          <Container>
            <div className="litter-detail-section-heading litter-detail-section-heading-left">
              <h2>Photo album</h2>
              <span className="dog-detail-heading-line" aria-hidden="true"></span>
            </div>
            <DogGallery images={galleryImages} reverseImages />
          </Container>
        </section>
      </LitterPage>
    </>
  );
}

export default VR2023Page;
